module.exports = __webpack_public_path__ + "img/icon_meeting_banquet.5d593aea.png";